"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_gateway_client_request_1 = require("./../../services/gateway-control//base-gateway-client-request");
var gateway_request_type_1 = require("./../../services/gateway-control/gateway-request-type");
/**
 * Data type for a GATEWAY_CLIENT_REQUEST update service request.
 */
var GatewayClientUpdateServiceRequest = /** @class */ (function (_super) {
    __extends(GatewayClientUpdateServiceRequest, _super);
    /**
     * Create a new GatewayClientUpdateServiceRequest instance
     *
     * @param sessionId  the gateway client session id
     * @param serviceDetails  updated service details
     */
    function GatewayClientUpdateServiceRequest(sessionId, serviceDetails) {
        var _this = _super.call(this, sessionId) || this;
        _this.type = gateway_request_type_1.GatewayRequestType.UPDATE_SERVICE;
        _this.serviceDetails = serviceDetails;
        return _this;
    }
    return GatewayClientUpdateServiceRequest;
}(base_gateway_client_request_1.BaseGatewayClientRequest));
exports.GatewayClientUpdateServiceRequest = GatewayClientUpdateServiceRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/gateway-client-update-service-request.js
// module id = 1262
// module chunks = 1